import React from 'react';
import AdminCustomReportTemplate from '@components/admin/admin-custom-report-template';
import ManageReportsTemplates from '@components/shared/manage-reports-templates';
import AdminRisks from '@pages/admin/admin-risks/admin-risks';
import AdminEvaluationModels from '@pages/admin/organisations/admin-evaluation-models/admin-evaluation-models';
import AdminOrgExcelListingConfig from '@pages/admin/reports/excel-listing-config';
import AdminSmStudyMembers from '@pages/admin/study/admin-sm-study-members/admin-sm-study-members';
import LegacyDashboards from '@pages/central-monitoring/legacy-dashboards';
import CentralMonitoringLegacyReports from '@pages/central-monitoring/legacy-reports';
import CMGenerationHistory from '@pages/central-monitoring/reporting/generation-history';
import CMManageSignatories from '@pages/central-monitoring/reporting/manage-signatories';
import ControlAction from '../../views/components/central-monitoring/control-action';
import ControlObservation from '../../views/components/central-monitoring/control-observation';
import AdminStudyAssessments from '../../views/pages/admin/study/admin-study-assessments';
import Features from '../features';
import Modules from '../modules';
import { IRoute } from './interfaces';
import { parsePathnameToActiveMenuInfo } from '@components-clean/page-nav/page-nav-menu-active-menu-info';
import { ManageCmIntegration } from '@pages-clean/admin/org/manage-cm-integration/manage-cm-integration';
import AdminDataViews from '@pages-clean/admin/study/admin-data-views';
import ManageHubs from '@pages-clean/admin/study/manage-hubs';
import ManagePanels from '@pages-clean/admin/study/manage-panels';
import ManageReviewPlans from '@pages-clean/admin/study/manage-review-plans';
import ManageTrialOsStudyTeam from '@pages-clean/admin/study/manage-trialos-study-team';
import { ControlsHub } from '@pages-clean/central-monitoring/controls-hub';
import DataView from '@pages-clean/central-monitoring/data-view';
import ViewDatasets from '@pages-clean/central-monitoring/dataset-hub';
import CM2GenerationHistory from '@pages-clean/central-monitoring/reports/generation-history';
import CM2ManageSignatories from '@pages-clean/central-monitoring/reports/manage-signatories';
import SiteHub from '@pages-clean/central-monitoring/site-hub';
import StudyHub from '@pages-clean/central-monitoring/study-hub';
import DataQualityPage from '@pages-clean/data-quality';
import DummyComponentsPage from '@pages-clean/dummy-page/dummy-page';
import DashboardAndWidgets from '@pages-clean/organisation/ManageRam/DashboardAndWidgets';
import ManageReviews from '@pages-clean/organisation/subject-monitoring/manage-reviews';
import ProtocolReviewHistory from '@pages-clean/protocol-insights/risk-iq/history';
import ProtocolReview from '@pages-clean/protocol-insights/risk-iq/review';
import ManageCmControls from '@pages-clean/risk-assessment/cm-controls';
import CTQFactors from '@pages-clean/risk-assessment/critical-to-quality-factors';
import RAMExcelListing from '@pages-clean/risk-assessment/reporting/excel-listings';
import RAMGenerationHistory from '@pages-clean/risk-assessment/reporting/generation-history';
import RAMManageSignatories from '@pages-clean/risk-assessment/reporting/manage-signatories';
import RiskDashboard from '@pages-clean/risk-assessment/risk-dashboard';
import RiskLog from '@pages-clean/risk-assessment/risk-log';
import CmControlChartsPopout from '@pages-clean/risk-assessment/risk-log/sections/childArea/cm-controls/popout';
import RiskMonitoring from '@pages-clean/risk-assessment/risk-monitoring';
import ManageReports from '@pages-clean/shared/reports/manage-reports';
import StudyTeam from '@pages-clean/shared/study-team';
import SubjectMonitoringGenerationHistory from '@pages-clean/subject-monitoring/reports/generation-history';
import SubjectMonitoringManageSignatories from '@pages-clean/subject-monitoring/reports/manage-signatories';
import SubjectHub from '@pages-clean/subject-monitoring/subject-hub';
import SubjectProfile from '@pages-clean/subject-monitoring/subject-profile';
import { mergeArrays } from '@utils-clean/array-helpers';
import { isDevOrTestEnv } from '@utils-clean/environment-helpers';
import { DashboardType, UserLevel } from 'types/graphql-global-types';
import Constants from 'utils/constants';
import AdminPanels from 'views/components/central-monitoring/panels/admin-panels';
import NoStudySelected from 'views/components/core/no-study-selected';
import AuditLog from 'views/pages/admin/audit-log';
import EventLog from 'views/pages/admin/event-log';
import AdminOrganisationUsers from 'views/pages/admin/organisations/admin-organisation-members';
import AdminOrganisationPermissions from 'views/pages/admin/organisations/admin-organisation-permissions';
import AdminOrganisationRoles from 'views/pages/admin/organisations/admin-organisation-roles';
import AdminOrganisationIndications from 'views/pages/admin/organisations/indications';
import AdminOrganisationLOVs from 'views/pages/admin/organisations/lovs';
import AdminOrganisationProducts from 'views/pages/admin/organisations/products';
import AdminOrganisationPrograms from 'views/pages/admin/organisations/programs';
import AdminOrganisationStudies from 'views/pages/admin/organisations/studies';
import AdminSiteDashboard from 'views/pages/admin/study/admin-site-dashboard';
import AdminStudyCohorts from 'views/pages/admin/study/admin-study-cohorts';
import AdminStudyCrfs from 'views/pages/admin/study/admin-study-crfs';
import AdminStudyDashboard from 'views/pages/admin/study/admin-study-dashboard';
import AdminStudyDataProcessingLog from 'views/pages/admin/study/admin-study-data-processing-log';
import AdminStudyDataReview from 'views/pages/admin/study/admin-study-data-review';
import AdminStudyDataSets from 'views/pages/admin/study/admin-study-data-sets/admin-study-data-sets';
import AdminStudyExtraData from 'views/pages/admin/study/admin-study-extra-data';
import AdminStudyMembers from 'views/pages/admin/study/admin-study-members/admin-study-members';
import ManageStudySettings from 'views/pages/admin/study/admin-study-settings';
import AdminStudyTreatmentArms from 'views/pages/admin/study/admin-study-treatment-arms';
import AdminSubjectVisitSchedules from 'views/pages/admin/study/admin-subject-visit-schedules';
import CentralMonitoringReport from 'views/pages/central-monitoring/central-monitoring-report';
import ManageCMActions from 'views/pages/central-monitoring/manage-actions';
import ManageCMObservations from 'views/pages/central-monitoring/manage-observations';
import Home from 'views/pages/home';
import StudyTeamGrid from 'views/pages/uam/study-team-grid';
import UserProfile from 'views/pages/uam/user-profile';
import { NullableStudy } from '@contexts/local-state-context';
import { IUser } from '@contexts/user-context';
import { StudyFields } from '@queries/generated/fragments.generated';
import { filterFeatureFlaggedRoutes } from '@config/routes/feature-flagged-routes';
import { PrivatePaths } from '@config/routes/paths';

const location = {
    state: {
        layout: 'PRIVATE',
    },
};

// IMPORTANT - For any new routes, the key and path must be added to paths.tsx and the path prop should be excluded from this file
// IMPORTANT - If the route also appears in the page nav, the route must also be added, with the same key, to page-nav-menu-items.data.tsx
// IMPORTANT - If the route does NOT appear in the page nav (this happens often with parameterised routes, e.g., risk-log-filter-ids)
//  Then the route for it in this file needs to have a moduleValue and an element defined, for UAM purposes

const allPrivateRoutes: IRoute[] = mergeArrays(
    PrivatePaths,
    [
        {
            key: 'home',
            component: Home,
            location,
        },
        {
            exclude: [Constants.SystemAdminLevel.Contributor],
            key: 'manage-evaluation-models',
            component: AdminEvaluationModels,
            location,
        },
        {
            key: 'org-risk-library',
            exclude: [Constants.SystemAdminLevel.Contributor],
            component: AdminRisks,
            location,
        },
        {
            key: 'admin-org-roles',
            exclude: [Constants.SystemAdminLevel.Contributor],
            component: AdminOrganisationRoles,
            location,
        },
        {
            key: 'admin-org-permissions-role-id',
            exclude: [Constants.SystemAdminLevel.Contributor],
            component: AdminOrganisationPermissions,
            location,
            orgAdmin: true,
        },
        {
            key: 'admin-org-permissions',
            exclude: [Constants.SystemAdminLevel.Contributor],
            component: AdminOrganisationPermissions,
            location,
            orgAdmin: true,
        },
        {
            key: 'admin-org-user-accounts',
            exclude: [Constants.SystemAdminLevel.Contributor],
            component: AdminOrganisationUsers,
            location,
            orgAdmin: true,
            trialOsAdmin: true,
        },
        {
            key: 'admin-org-event-log',
            exclude: [Constants.SystemAdminLevel.Contributor],
            componentFn: () => <EventLog userLevel={UserLevel.ORGANISATION} />,
            location,
        },
        {
            key: 'admin-org-panels',
            exclude: [Constants.SystemAdminLevel.Contributor],
            componentFn: () => <AdminPanels studyId={Constants.ObjectId.Empty} />,
            location,
            admin: Constants.SystemAdminLevel.Reviewer,
        },
        {
            key: 'admin-org-studies',
            exclude: [Constants.SystemAdminLevel.Contributor],
            component: AdminOrganisationStudies,
            location,
        },
        {
            key: 'admin-org-indications',
            exclude: [Constants.SystemAdminLevel.Contributor],
            component: AdminOrganisationIndications,
            location,
        },
        {
            key: 'admin-org-programs',
            exclude: [Constants.SystemAdminLevel.Contributor],
            component: AdminOrganisationPrograms,
            location,
        },
        {
            key: 'admin-org-products',
            exclude: [Constants.SystemAdminLevel.Contributor],
            component: AdminOrganisationProducts,
            location,
        },
        {
            key: 'admin-org-lovs',
            exclude: [Constants.SystemAdminLevel.Contributor],
            component: AdminOrganisationLOVs,
            location,
        },
        {
            key: 'cm2-controls-hub',
            component: ControlsHub,
            module: Modules.CentralMonitoring2,
            feature: Features.CentralMonitoring,
            location,
            theme: 'default',
            pageBreadcrumbs: ['centralMonitoring', 'cm:controlsHub.title'],
            pageToolbarComponents: [{ component: 'popOut' }, { component: 'legendToggle' }],
            isCentralMonitoringToolkitEnabled: true,
        },
        {
            key: 'cm2-study-hub',
            component: StudyHub,
            module: Modules.CentralMonitoring2,
            feature: Features.CentralMonitoring,
            location,
            theme: 'default',
            pageBreadcrumbs: ['centralMonitoring', 'cm:studyHub.title'],
            pageToolbarComponents: [{ component: 'popOut' }, { component: 'legendToggle' }],
            isCentralMonitoringToolkitEnabled: true,
        },
        {
            key: 'cm2-site-hub',
            component: SiteHub,
            module: Modules.CentralMonitoring2,
            feature: Features.CentralMonitoring,
            location,
            theme: 'default',
            pageToolbarComponents: [{ component: 'popOut' }],
            pageBreadcrumbs: ['centralMonitoring', 'cm:siteHub.title'],
            isCentralMonitoringToolkitEnabled: true,
        },
        {
            key: 'cm2-dataset-hub',
            component: ViewDatasets,
            module: Modules.CentralMonitoring2,
            feature: Features.CentralMonitoring,
            location,
            theme: 'default',
            pageToolbarComponents: [{ component: 'popOut' }],
            pageBreadcrumbs: ['centralMonitoring', 'cm:datasetHub.title'],
        },
        {
            key: 'cm2-data-views',
            module: Modules.CentralMonitoring2,
            moduleValue: Constants.Modules.CM2,
            element: Constants.PageElements.DataViewsCM2,
            feature: Features.CentralMonitoring,
            component: DataView,
            location,
            theme: 'default',
            pageToolbarComponents: [{ component: 'popOut' }, { component: 'legendToggle' }],
            pageBreadcrumbs: [
                'centralMonitoring',
                'cm:dataViews',
                (state, loc) => {
                    const dataViewId = parsePathnameToActiveMenuInfo(loc.pathname)?.thirdLevel?.params?.dataView;
                    const res = state.dataViewConfig?.find((x) => x?.id === dataViewId);
                    return res?.name || '';
                },
            ], // "Data Views" probably isn't an appropriate breadcrumb here
            isCentralMonitoringToolkitEnabled: true,
        },
        {
            key: 'cm2-study-team',
            componentFn: ({ study }: { study: NullableStudy }) => (
                <StudyTeam key={Modules.CentralMonitoring2.id} study={study} module={Modules.CentralMonitoring2} />
            ),
            module: Modules.CentralMonitoring2,
            feature: Features.CentralMonitoring,
            location,
            theme: 'default',
            pageBreadcrumbs: ['centralMonitoring', 'cm:studyTeam'],
            isCentralMonitoringToolkitEnabled: false,
        },
        {
            key: 'cm2-generation-history',
            component: CM2GenerationHistory,
            module: Modules.CentralMonitoring2,
            feature: Features.CentralMonitoring,
            location,
            theme: 'default',
            pageBreadcrumbs: ['centralMonitoring', 'cm:reporting', 'cm:generationHistory'],
        },
        {
            key: 'cm2-reports',
            componentFn: ({ user, study }: { user: IUser; study: NullableStudy }) =>
                study ? (
                    <ManageReports studyId={study?.id as string} user={user} module={Constants.Modules.CM2} />
                ) : (
                    <NoStudySelected />
                ),
            module: Modules.CentralMonitoring2,
            feature: Features.CentralMonitoring,
            location,
            theme: 'default',
            pageBreadcrumbs: ['centralMonitoring', 'cm:reporting', 'cm:reports'],
        },
        {
            key: 'cm2-manage-signatories',
            component: CM2ManageSignatories,
            module: Modules.CentralMonitoring2,
            feature: Features.CentralMonitoring,
            location,
            theme: 'default',
            pageBreadcrumbs: ['centralMonitoring', 'cm:reporting', 'cm:manageSignatories'],
        },
        {
            key: 'cm2-generation-history',
            component: CM2GenerationHistory,
            module: Modules.CentralMonitoring2,
            feature: Features.CentralMonitoring,
            location,
            theme: 'default',
            pageBreadcrumbs: ['centralMonitoring', 'cm:reporting', 'cm:generationHistory'],
        },
        {
            key: 'cm2-reports',
            componentFn: ({ user, study }: { user: IUser; study: NullableStudy }) =>
                study ? (
                    <ManageReports studyId={study?.id as string} user={user} module={Constants.Modules.CM2} />
                ) : (
                    <NoStudySelected />
                ),
            module: Modules.CentralMonitoring2,
            feature: Features.CentralMonitoring,
            location,
            theme: 'default',
            pageBreadcrumbs: ['centralMonitoring', 'cm:reporting', 'cm:reports'],
        },
        {
            key: 'cm2-manage-signatories',
            component: CM2ManageSignatories,
            module: Modules.CentralMonitoring2,
            feature: Features.CentralMonitoring,
            location,
            theme: 'default',
            pageBreadcrumbs: ['centralMonitoring', 'cm:reporting', 'cm:manageSignatories'],
        },
        {
            key: 'cm-study-team',
            component: StudyTeamGrid,
            module: Modules.CentralMonitoring,
            feature: Features.CentralMonitoring,
            location,
            breadcrumbs: ['centralMonitoring', 'Study Team'],
        },
        {
            key: 'cm-reports',
            componentFn: ({ study }: { study: NullableStudy }) =>
                study ? (
                    <ManageReportsTemplates studyId={study?.id} module={Constants.Modules.CM} />
                ) : (
                    <NoStudySelected />
                ),
            module: Modules.CentralMonitoring,
            feature: Features.CentralMonitoring,
            location,
        },
        {
            key: 'sm-subject-hub',
            component: SubjectHub,
            module: Modules.SubjectMonitoring,
            feature: Features.SubjectMonitoring,
            location,
            theme: 'default',
            pageToolbarComponents: [{ component: 'popOut' }],
            pageBreadcrumbs: ['subjectMonitoring', 'sm:subjectHub.title'],
            isSubjectMonitoringToolkitEnabled: true,
        },
        {
            key: 'sm-subject-profile',
            component: SubjectProfile,
            module: Modules.SubjectMonitoring,
            feature: Features.SubjectMonitoring,
            location,
            theme: 'default',
            pageToolbarComponents: [{ component: 'subjectMonitoringProfileOverviewToggle' }, { component: 'popOut' }],
            pageBreadcrumbs: ['subjectMonitoring', 'sm:subjectProfile.title'],
            isSubjectMonitoringToolkitEnabled: true,
        },
        {
            key: 'sm-study-team',
            componentFn: ({ study }: { study: NullableStudy }) => (
                <StudyTeam
                    key={Modules.SubjectMonitoring.id}
                    study={study}
                    module={Modules.SubjectMonitoring}
                    isSmStudyTeam
                />
            ),
            module: Modules.SubjectMonitoring,
            feature: Features.SubjectMonitoring,
            location,
            theme: 'default',
            pageBreadcrumbs: ['subjectMonitoring', 'sm:studyTeam'],
            isSubjectMonitoringToolkitEnabled: false,
        },
        {
            key: 'sm-reports',
            componentFn: ({ user, study }: { user: IUser; study: NullableStudy }) =>
                study ? (
                    <ManageReports studyId={study?.id as string} user={user} module={Constants.Modules.SM} />
                ) : (
                    <NoStudySelected />
                ),
            module: Modules.SubjectMonitoring,
            feature: Features.SubjectMonitoring,
            location,
            theme: 'default',
            pageBreadcrumbs: ['subjectMonitoring', 'sm:reporting', 'sm:reports'],
        },
        {
            key: 'sm-generation-history',
            component: SubjectMonitoringGenerationHistory,
            module: Modules.SubjectMonitoring,
            feature: Features.SubjectMonitoring,
            location,
            theme: 'default',
            pageBreadcrumbs: ['subjectMonitoring', 'sm:reporting', 'sm:generationHistory'],
        },
        {
            key: 'sm-manage-signatories',
            component: SubjectMonitoringManageSignatories,
            module: Modules.SubjectMonitoring,
            feature: Features.SubjectMonitoring,
            location,
            theme: 'default',
            pageBreadcrumbs: ['subjectMonitoring', 'sm:reporting', 'sm:manageSignatories'],
        },
        {
            key: 'cm-legacy-reports',
            component: CentralMonitoringLegacyReports,
            module: Modules.CentralMonitoring,
            feature: Features.CentralMonitoring,
            location,
        },
        {
            key: 'cm-manage-signatories',
            componentFn: ({ study }: any) =>
                study ? <CMManageSignatories studyId={study?.id} module={Constants.Modules.CM} /> : <NoStudySelected />,
            module: Modules.CentralMonitoring,
            feature: Features.CentralMonitoring,
            location,
        },
        {
            key: 'cm-review-report',
            component: CentralMonitoringReport,
            module: Modules.CentralMonitoring,
            feature: Features.CentralMonitoring,
            location,
        },
        {
            key: 'cm-generation-history',
            componentFn: () => <CMGenerationHistory module={Constants.Modules.CM} />,
            module: Modules.CentralMonitoring,
            feature: Features.CentralMonitoring,
            location,
        },
        {
            key: 'cm-study-dashboard',
            componentFn: () => <LegacyDashboards type={DashboardType.STUDY} />,
            module: Modules.CentralMonitoring,
            feature: Features.CentralMonitoring,
            location,
        },
        {
            key: 'cm-site-dashboard',
            componentFn: () => <LegacyDashboards type={DashboardType.SITE} />,
            module: Modules.CentralMonitoring,
            feature: Features.CentralMonitoring,
            location,
        },
        {
            key: 'cm-manage-observations',
            componentFn: ({ study }: any) =>
                study ? (
                    <ControlObservation studyId={study.id}>
                        {(handleDeleteObs: Function, handleRestoreObs: Function) => (
                            <ManageCMObservations
                                handleDeleteObs={handleDeleteObs}
                                handleRestoreObs={handleRestoreObs}
                                study={study}
                            />
                        )}
                    </ControlObservation>
                ) : (
                    <NoStudySelected />
                ),
            module: Modules.CentralMonitoring,
            feature: Features.CentralMonitoring,
            location,
        },
        {
            key: 'cm-manage-actions',
            componentFn: ({ study }: any) =>
                study ? (
                    <ControlAction studyId={study.id}>
                        {(handleDeleteAct: Function, handleRestoreAct: Function) => (
                            <ManageCMActions
                                study={study}
                                handleDeleteAct={handleDeleteAct}
                                handleRestoreAct={handleRestoreAct}
                            />
                        )}
                    </ControlAction>
                ) : (
                    <NoStudySelected />
                ),
            module: Modules.CentralMonitoring,
            feature: Features.CentralMonitoring,
            location,
        },
        {
            key: 'manage-study-members',
            component: AdminStudyMembers,
            exclude: [Constants.SystemAdminLevel.Contributor],
            location,
        },
        {
            key: 'manage-sm-study-members',
            component: AdminSmStudyMembers,
            exclude: [Constants.SystemAdminLevel.Contributor],
            location,
        },
        {
            key: 'manage-trialos-study-members',
            component: ManageTrialOsStudyTeam,
            exclude: [Constants.SystemAdminLevel.Contributor],
            trialOsAdmin: true,
            location,
            theme: 'default',
            pageBreadcrumbs: ['studyAdmin', 'admin:manageTrialOsStudyTeam'],
        },
        {
            key: 'manage-study-panels',
            exclude: [Constants.SystemAdminLevel.Contributor],
            componentFn: ({ study }: any) => <AdminPanels studyId={study?.id} />,
            location,
        },
        {
            key: 'manage-study-dashboard',
            exclude: [Constants.SystemAdminLevel.Contributor],
            component: AdminStudyDashboard,
            location,
        },
        {
            key: 'manage-hubs',
            exclude: [Constants.SystemAdminLevel.Contributor],
            component: ManageHubs,
            pageBreadcrumbs: ['studyAdmin', 'admin:manageHubs'],
            location,
            theme: 'default',
        },
        {
            key: 'manage-panels',
            exclude: [Constants.SystemAdminLevel.Contributor],
            component: ManagePanels,
            pageBreadcrumbs: ['studyAdmin', 'admin:managePanels.pageTitle'],
            location,
            theme: 'default',
        },
        {
            key: 'manage-data-views',
            exclude: [Constants.SystemAdminLevel.Contributor],
            componentFn: ({ study, user }: { user: IUser; study: StudyFields }) => (
                <AdminDataViews study={study} user={user} />
            ),
            pageBreadcrumbs: ['studyAdmin', 'admin:manageDataViews'],
            location,
            theme: 'default',
        },
        {
            key: 'manage-site-dashboard',
            exclude: [Constants.SystemAdminLevel.Contributor],
            component: AdminSiteDashboard,
            location,
        },
        {
            key: 'manage-study-extra-data',
            exclude: [Constants.SystemAdminLevel.Contributor],
            componentFn: ({ study }: any) => <AdminStudyExtraData study={study} />,
            location,
        },
        {
            key: 'manage-study-data-review',
            exclude: [Constants.SystemAdminLevel.Contributor],
            component: AdminStudyDataReview,
            location,
        },
        {
            key: 'manage-study-datasets',
            exclude: [Constants.SystemAdminLevel.Contributor],
            component: AdminStudyDataSets,
            location,
        },
        {
            key: 'manage-study-cohorts',
            exclude: [Constants.SystemAdminLevel.Contributor],
            component: AdminStudyCohorts,
            location,
            admin: Constants.SystemAdminLevel.Reviewer,
        },
        {
            key: 'manage-study-treatment-arms',
            exclude: [Constants.SystemAdminLevel.Contributor],
            component: AdminStudyTreatmentArms,
            location,
            admin: Constants.SystemAdminLevel.Reviewer,
        },
        {
            key: 'manage-visit-schedules',
            exclude: [Constants.SystemAdminLevel.Contributor],
            component: AdminSubjectVisitSchedules,
            location,
        },
        {
            key: 'data-processing-log',
            exclude: [Constants.SystemAdminLevel.Contributor],
            component: AdminStudyDataProcessingLog,
            location,
        },
        {
            key: 'manage-study-crfs',
            component: AdminStudyCrfs,
            exclude: [Constants.SystemAdminLevel.Contributor],
            location,
        },
        {
            key: 'manage-study-assessments',
            component: AdminStudyAssessments,
            exclude: [Constants.SystemAdminLevel.Contributor],
            location,
        },
        {
            key: 'manage-study-settings',
            component: ManageStudySettings,
            exclude: [Constants.SystemAdminLevel.Contributor],
            location,
        },
        {
            key: 'dummy-components-page',
            exclude: !isDevOrTestEnv()
                ? [
                      Constants.SystemAdminLevel.None,
                      Constants.SystemAdminLevel.Reviewer,
                      Constants.SystemAdminLevel.Contributor,
                      Constants.SystemAdminLevel.Administrator,
                      Constants.SystemAdminLevel.SysAdmin,
                  ]
                : [null],
            component: DummyComponentsPage,
            pageBreadcrumbs: ['dummyComponentsPage'],
            theme: 'default',
        },
        {
            key: 'user-profile',
            component: UserProfile,
        },
        {
            key: 'audit-log',
            exclude: [Constants.SystemAdminLevel.Contributor],
            component: AuditLog,
            location,
        },

        {
            key: 'admin-org-excel-listing',
            exclude: [Constants.SystemAdminLevel.Contributor],
            component: AdminOrgExcelListingConfig,
            location,
        },
        {
            key: 'admin-org-report-templates',
            exclude: [Constants.SystemAdminLevel.Contributor],
            component: AdminCustomReportTemplate,
            location,
        },
        {
            key: 'ra-critical-to-quality-factors',
            component: CTQFactors,
            module: Modules.RiskAssessment,
            feature: Features.RiskAssessment,
            location,
            theme: 'default',
            pageToolbarComponents: [
                { component: 'actionButton' },
                { component: 'commentsToggle', permissionElement: Constants.PageElements.CtqComments },
            ],
            pageBreadcrumbs: ['riskAssessment', 'ram:ctqf.title'],
            isRiskAssessmentToolkitEnabled: true,
        },
        {
            key: 'ra-risk-log',
            component: RiskLog,
            module: Modules.RiskAssessment,
            feature: Features.RiskAssessment,
            location,
            theme: 'default',
            pageToolbarComponents: [
                { component: 'actionButton' },
                { component: 'riskReviewActions' },
                { component: 'commentsToggle', permissionElement: Constants.PageElements.RiskLogComments },
            ],
            pageBreadcrumbs: ['riskAssessment', 'ram:riskLog.title'],
            isRiskAssessmentToolkitEnabled: true,
        },
        {
            key: 'ra-risk-log-filter-id',
            component: RiskLog,
            module: Modules.RiskAssessment,
            moduleValue: Constants.Modules.RAM,
            element: Constants.PageElements.RiskLog,
            feature: Features.RiskAssessment,
            location,
            theme: 'default',
            pageToolbarComponents: [{ component: 'actionButton' }],
            pageBreadcrumbs: ['riskAssessment', 'ram:riskLog.title'],
        },
        {
            key: 'ra-risk-log-filter-impact-ltd',
            component: RiskLog,
            module: Modules.RiskAssessment,
            moduleValue: Constants.Modules.RAM,
            element: Constants.PageElements.RiskLog,
            feature: Features.RiskAssessment,
            location,
            theme: 'default',
            pageToolbarComponents: [{ component: 'actionButton' }],
            pageBreadcrumbs: ['riskAssessment', 'ram:riskLog.title'],
        },
        {
            key: 'ra-risk-log-filter-category-rating',
            componentFn: RiskLog,
            module: Modules.RiskAssessment,
            moduleValue: Constants.Modules.RAM,
            element: Constants.PageElements.RiskLog,
            feature: Features.RiskAssessment,
            location,
            theme: 'default',
            pageToolbarComponents: [{ component: 'actionButton' }],
            pageBreadcrumbs: ['riskAssessment', 'ram:riskLog.title'],
        },
        {
            key: 'ra-risk-log-filter-review-status',
            componentFn: RiskLog,
            module: Modules.RiskAssessment,
            moduleValue: Constants.Modules.RAM,
            element: Constants.PageElements.RiskLog,
            feature: Features.RiskAssessment,
            location,
            theme: 'default',
            pageToolbarComponents: [{ component: 'actionButton' }],
            pageBreadcrumbs: ['riskAssessment', 'ram:riskLog.title'],
        },
        {
            key: 'ra-risk-log-cmcontrol-chart-popout',
            component: CmControlChartsPopout,
            module: Modules.RiskAssessment,
            moduleValue: Constants.Modules.RAM,
            element: Constants.PageElements.CMControls,
            feature: Features.RiskAssessment,
            location,
            theme: 'default',
            pageToolbarComponents: [{ component: 'actionButton' }],
            pageBreadcrumbs: ['riskAssessment', 'ram:riskLog.popOut.cmControlCharts.title'],
        },
        {
            key: 'ra-risk-dashboard',
            component: RiskDashboard,
            module: Modules.RiskAssessment,
            feature: Features.RiskAssessment,
            location,
            theme: 'default',
            pageToolbarComponents: [{ component: 'actionButton' }],
            pageBreadcrumbs: ['riskAssessment', 'ram:riskDashboard.title'],
        },
        {
            key: 'data-quality-nav',
            component: DataQualityPage,
            module: Modules.DataQuality,
            feature: Features.DataQuality,
            location,
            theme: 'default',
            pageToolbarComponents: [{ component: 'actionButton' }],
            pageBreadcrumbs: ['dataQuality'],
        },
        {
            key: 'ra-reports',
            componentFn: ({ user, study }: { user: IUser; study: NullableStudy }) =>
                study ? (
                    <ManageReports studyId={study?.id as string} user={user} module={Constants.Modules.RAM} />
                ) : (
                    <NoStudySelected />
                ),
            module: Modules.RiskAssessment,
            feature: Features.RiskAssessment,
            location,
            theme: 'default',
            pageBreadcrumbs: ['riskAssessment', 'ra:reporting', 'ra:reports'],
        },
        {
            key: 'ra-generation-history',
            component: RAMGenerationHistory,
            module: Modules.RiskAssessment,
            feature: Features.RiskAssessment,
            location,
            theme: 'default',
            pageBreadcrumbs: ['riskAssessment', 'ra:reporting', 'ra:generationHistory'],
        },
        {
            key: 'ra-manage-signatories',
            component: RAMManageSignatories,
            module: Modules.RiskAssessment,
            feature: Features.RiskAssessment,
            location,
            theme: 'default',
            pageBreadcrumbs: ['riskAssessment', 'ra:reporting', 'ra:manageSignatories'],
        },
        {
            key: 'ra-excel-listing',
            component: RAMExcelListing,
            module: Modules.RiskAssessment,
            feature: Features.RiskAssessment,
            location,
            theme: 'default',
            pageBreadcrumbs: ['ra:riskAssessment', 'ra:excelListing'],
        },
        {
            key: 'ra-study-team',
            componentFn: ({ study }: { study: NullableStudy }) => (
                <StudyTeam key={Modules.RiskAssessment.id} study={study} module={Modules.RiskAssessment} />
            ),
            module: Modules.RiskAssessment,
            feature: Features.RiskAssessment,
            location,
            theme: 'default',
            pageBreadcrumbs: ['riskAssessment', 'common:studyTeam'],
        },
        {
            key: 'ra-risk-monitoring',
            componentFn: RiskMonitoring,
            module: Modules.RiskAssessment,
            feature: Features.RiskAssessment,
            location,
            theme: 'default',
            pageBreadcrumbs: ['riskAssessment', 'ram:riskMonitoring:title'],
        },
        {
            key: 'ra-manage-cm-controls',
            component: ManageCmControls,
            module: Modules.RiskAssessment,
            feature: Features.RiskAssessment,
            location,
            theme: 'default',
            pageBreadcrumbs: ['riskAssessment', 'ram:manageCmControls.title'],
            isRiskAssessmentToolkitEnabled: true,
        },
        {
            // ADO 90806 - gated by Trial.OS RiskIQ access (nav + page), not by a RAM module/permission
            key: 'protocol-insights-risk-iq-review',
            component: ProtocolReview,
            location,
            theme: 'default',
            pageBreadcrumbs: [
                'protocolInsights:title',
                'protocolInsights:riskIQ.title',
                'protocolInsights:riskIQ.protocolReview.title',
            ],
            pageToolbarComponents: [{ component: 'commentsToggle' }],
        },
        {
            key: 'protocol-insights-risk-iq-history',
            component: ProtocolReviewHistory,
            location,
            theme: 'default',
            pageBreadcrumbs: [
                'protocolInsights:title',
                'protocolInsights:riskIQ.title',
                'protocolInsights:riskIQ.history.title',
            ],
        },
        {
            key: 'sm-manage-review-plans',
            component: ManageReviewPlans,
            location,
            theme: 'default',
            pageBreadcrumbs: ['sm:subjectMonitoring', 'sm:manageReviewPlans'],
        },
        {
            key: 'admin-org-sm-manage-reviews',
            component: ManageReviews,
            exclude: [Constants.SystemAdminLevel.Contributor],
            location,
            theme: 'default',
            include: [
                Constants.SystemAdminLevel.Reviewer,
                Constants.SystemAdminLevel.Administrator,
                Constants.SystemAdminLevel.SysAdmin,
            ],
        },
        {
            key: 'admin-org-ram-dashboard',
            componentFn: DashboardAndWidgets,
            exclude: [Constants.SystemAdminLevel.Contributor],
            location,
            theme: 'default',
            pageBreadcrumbs: ['admin:manageRam:mainNav', 'admin:manageRam:navDashboard'],
        },
        {
            key: 'admin-org-manage-cm-integration',
            location,
            component: ManageCmIntegration,
            theme: 'default',
            pageBreadcrumbs: ['organisationAdmin', 'admin:manageCMIntegration.mainNav'],
        },
    ],
    (item) => item.key,
);

// Feature-flagged routes (e.g. RiskIQ) are filtered from the MERGED list, because PrivatePaths also contains them.
const PrivateRoutes = filterFeatureFlaggedRoutes(allPrivateRoutes);

export default PrivateRoutes;
